import api from '../config/axiosConfig';

export const TipificacionService = {
    fetchTipificaciones: async (token) => {
        try {
            const response = await api.get('/ajustes/tipificaciones', {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.tipificaciones || [];
        } catch (error) {
            console.error('Error en TipificacionService.fetchTipificaciones:', error);
            throw error;
        }
    },
    guardarTipificacion: async ({ token, formData, editingItem }) => {
        try {
            if (editingItem) {
                await api.put(`/ajustes/tipificaciones/${editingItem.id}`,
                    formData,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            } else {
                await api.post('/ajustes/tipificaciones', formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
        } catch (error) {
            console.error('Error en TipificacionService.guardarTipificacion:', error);
            throw error;
        }
    },
};
